import { createContext, useContext, useState } from 'react'
import { api } from '../services/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')) } catch { return null }
  })

  const [currentFazenda, setCurrentFazendaState] = useState(() => {
    try { return JSON.parse(localStorage.getItem('currentFazenda')) } catch { return null }
  })

  const [currentSafra, setCurrentSafraState] = useState(() => {
    try { return JSON.parse(localStorage.getItem('currentSafra')) } catch { return null }
  })

  function setCurrentFazenda(fazenda) {
    if (fazenda) {
      localStorage.setItem('currentFazenda', JSON.stringify(fazenda))
    } else {
      localStorage.removeItem('currentFazenda')
    }
    setCurrentFazendaState(fazenda)
    // trocar de fazenda invalida a safra selecionada
    setCurrentSafra(null)
  }

  function setCurrentSafra(safra) {
    if (safra) {
      localStorage.setItem('currentSafra', JSON.stringify(safra))
      localStorage.setItem('currentSafraId', String(safra.id))
    } else {
      localStorage.removeItem('currentSafra')
      localStorage.removeItem('currentSafraId')
    }
    setCurrentSafraState(safra)
  }

  async function login(username, password) {
    const data = await api.login(username, password)
    localStorage.setItem('token', data.access_token)
    const userData = { username: data.username, role: data.role }
    localStorage.setItem('user', JSON.stringify(userData))
    setUser(userData)

    // Para operator/owner: fazenda vem diretamente do token
    if (data.role !== 'admin' && data.fazenda_id) {
      setCurrentFazenda({ id: data.fazenda_id, name: data.fazenda_name })
    } else {
      // Admin seleciona a fazenda manualmente após o login
      setCurrentFazenda(null)
    }
    setCurrentSafra(null)

    return data.role
  }

  function logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('currentFazenda')
    setUser(null)
    setCurrentFazenda(null)
    setCurrentSafra(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, currentFazenda, setCurrentFazenda, currentSafra, setCurrentSafra }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
